<ng-container *ngIf="user$ | async as _user">
  <div style="zoom:0.8">
    <div class="menu-item px-3">
      <div class="menu-content d-flex align-items-center px-3">
        <div class="symbol symbol-50px me-5">
          <img *ngIf="!_user.picture" src="/assets/media/icons/custom/user.svg" alt="Avatar" />
          <img *ngIf="_user.picture" [src]="_user.picture" alt="Avatar" />
        </div>

        <div class="d-flex flex-column">
          <div class="fw-bolder d-flex align-items-center fs-5">
            {{ _user.given_name }}
          </div>
          <div class="fw-bold text-muted text-hover-primary fs-7 cursor-pointer">
            {{ _user.email }}
          </div>
        </div>
      </div>
    </div>

<!--    <ng-container [hidden]="true">
      <div class="separator my-2"></div>

      <div class="menu-item px-5 my-1" *ngIf="_user.id === 1">
        <a (click)="setupWizard()" class="menu-link px-5">
          Account Setup
        </a>
      </div>

      <div class="menu-item px-5 my-1">
        <a (click)="supportWizard()" class="menu-link px-5">
          Get Support
        </a>
      </div>
    </ng-container>-->

    <div class="separator my-2"></div>

   <div class="menu-item px-5 my-1" *ngIf="canChangePassword">
      <a (click)="passwordModal()" class="menu-link px-5">
        Change My Password
      </a>
    </div>

    <div class="menu-item px-5">
      <a (click)="switchAccount()" class="menu-link px-5 cursor-pointer">Switch Account</a>
    </div>
    <div class="menu-item px-5">
      <a (click)="logout()" class="menu-link px-5 cursor-pointer">Sign Out</a>
    </div>
  </div>
</ng-container>
